var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ADDRESS.funnel_v2)?_c('configuration-order-summary'):_c('checkout-summary-default')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }